import apiClient from './config';
import { CONTACT_ENDPOINTS } from './endpoints';

/**
 * Contact Service
 * Centralized API calls for contact/support using defined endpoints
 */
const contactService = {
  // Create support ticket
  createSupport: (data) => {
    return apiClient.post(CONTACT_ENDPOINTS.CREATE_SUPPORT, data);
  },
};

export default contactService;
